import { Linking } from 'react-native'
import { AccessDeniedError, ResultWithoutRecordsError, UnexpectedError } from '@/domain/errors'
import { OpenNfse, OpenNfseParams } from '@/domain/usecases'
import { HttpClient, HttpStatusCode } from '@/data/protocols/http'

export class RemoteOpenNfse implements OpenNfse {
  constructor (
    private readonly url: string,
    private readonly httpGetClient: HttpClient<string>
  ) {}

  async open (params: OpenNfseParams): Promise<void> {
    const { linkAutenticidade, ...dataParams } = params

    const { body, statusCode } = await this.httpGetClient.request({
      url: `${this.url}/api/EspelhoNotaFiscal`,
      method: 'get',
      params: {
        ...dataParams,
        producao: true,
        naty: false
      }
    })

    switch (statusCode) {
      case HttpStatusCode.ok:
        if (body) {
          window.open(`/${OpenNfse.RN.FOLDER_DEFAULT_NFSE}/${body}`, '_blank')
        } else if (linkAutenticidade) {
          await Linking.openURL(this.tryOpenHttps(linkAutenticidade))
        } else {
          throw new ResultWithoutRecordsError('Visualização da NFS-e indisponível: PDF e URL de autenticação não encontrados.')
        }
        break
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }

  private readonly tryOpenHttps = (url: string): string => url.startsWith('http://') ? url.replace(/^http:\/\//, 'https://') : url
}
